import React from 'react';

import {CompetitionsSliderWidgetProps} from "../models/competitions-slider-widget.props";
import {CompetitionsSliderWidgetOddsTransparent} from "./odds/competitions-slider-widget.odds-transparent";

export class CompetitionsSliderWidgetRightBarProps extends CompetitionsSliderWidgetProps {
}

export const CompetitionsSliderWidgetRightBar = (({controller}: CompetitionsSliderWidgetRightBarProps) => {
  return (
    <div className={['competitions-slider-widget-right-bar-container', controller.state.hasOdds ? 'competitions-slider-widget-has-odds': ''].join(' ')}>
      <CompetitionsSliderWidgetOddsTransparent controller={controller} />
    </div>
  )
});
